// src/blocks/move/moveRight.ts

import * as Blockly from 'blockly';
import { javascriptGenerator } from 'blockly/javascript';
import { BlocklyFields } from '../../BlocklyFields';
import i18next from 'i18next';

export function initJumpLeftBlock() {

    Blockly.Blocks[BlocklyFields.JUMP_LEFT] = {
        init: function () {
            this.jsonInit({
                "type": BlocklyFields.JUMP_LEFT,
                "message0": '%1 ' + i18next.t('blockly.jump.left.message', 'Jump left'),
                "args0": [
                    {
                        "type": "field_image",
                        "src": "/images/blocks/left.png", // Lien vers votre icône (chemin relatif ou absolu)
                        "width": 16,   // Largeur de l'image
                        "height": 16,  // Hauteur de l'image

                    }
                ],
                "previousStatement": null,
                "nextStatement": null,
                "colour": '#E55570',
                "tooltip": i18next.t('blockly.jump.left.tooltip', ''),
                "helpUrl": ""
            });
        },
    };
    javascriptGenerator.forBlock[BlocklyFields.JUMP_LEFT] = function (block, generator) {
        return 'await jumpCharacter(180);\n';
    }
}
